import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState, useRef } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Header_Home from "../Component/Header_Home.js";
import Header from "../Component/Header.js";
import "../../App.css";
import "react-datepicker/dist/react-datepicker.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "../LetterDigiCom/letterDigiCom-styles.css";
import { getParameterAPI } from "../PolicyDetail/PolicyDetailService/policyDetailService.js";
import {
  policyLoanEnquiry,
  policyLoanHistory,
} from "./PolicyDebtService/policyDebtService.js";
import Skeleton from "react-loading-skeleton";
import "moment/locale/th";
import CircularProgress from "@mui/material/CircularProgress";
import { Modal, Col, Button } from "react-bootstrap";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import CollapseTable from "./table.jsx";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { CurrencyFormater } from "../../util/index.js";
import "./policyDebt-styles.css";
import { CurrencyFormaterRound } from "../../util/function.js";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  InputAdornment,
  Grid,
} from "@mui/material";
import { payment } from "../Payment/PaymentService/paymentService.js";
import { NumericFormat } from "react-number-format";

const PolicyDebt = () => {
  const theme = createTheme({
    components: {
      MuiTableHead: {
        styleOverrides: {
          root: {},
        },
      },
    },
  });

  const [loading, setLoading] = useState(false);
  const [LoadingContent, setLoadingContent] = useState(true);
  const [activeTab, setActiveTab] = useState();
  const location = useLocation();
  const rcData = location.state || {};
  const [cusTel, setCusTel] = useState("");
  const [dataLoanEnquiry, setDataLoanEnquiry] = useState("");
  const [dataLoanHistory, setDataLoanHistory] = useState([""]);
  let [searchParams, setSearchParams] = useSearchParams();
  const dataParams = location.state || {};
  const policyNo = dataParams.policyNo || "";
  let navigate = useNavigate();
  const [minimumPayAmt, setMinimumPayAmt] = useState("");
  const [policyDebt, setPolicyDebt] = useState("policyDebt");
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("full");
  const [customAmount, setCustomAmount] = useState("");
  const [radioAmt, setRadioAmt] = useState("");
  const [customAmt, setCustomAmt] = useState("");
  const [rawAmt, setRawAmt] = useState("");
  const [displayValue, setDisplayValue] = useState("");
  const [errorText, setErrorText] = useState("");
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [totalDebt, setTotalDebt] = useState("");

  const handleSelect = (key) => {
    setActiveTab(key);
  };

  const getTel = async () => {
    const result = await getParameterAPI(12);
    const payload = result.payload;
    const cusTel = payload.find((item) => item.code === "CUS_SERV_TEL");
    const variable1 = cusTel.variable1;
    setCusTel(variable1);
  };

  const policyLoanEnquiryAPI = async () => {
    const result = await policyLoanEnquiry(policyNo);
    setLoadingContent(false);
    setDataLoanEnquiry(result.data);
    console.log(result.data);
    setMinimumPayAmt(
      result.data.interestAmount + result.data.interestAplAmount
    );
    setTotalDebt(
      CurrencyFormater(result.data.totalLoanAmount + result.data.totalAplAmount)
    );

    // console.log(result.data);
  };

  const policyLoanHistoryAPI = async () => {
    const result = await policyLoanHistory(policyNo);
    // setLoadingContent(false);
    setDataLoanHistory(result.data);
    // console.log(result.data);
  };

  const goBack = () => {
    navigate("/policyList");
  };

  useEffect(() => {
    getTel();
    policyLoanEnquiryAPI();
    console.log(rcData);
    console.log(dataLoanEnquiry);
  }, []);

  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear() + 543;

  const todayDate = `${day}/${month}/${year}`;
  const debtAmt =
    selectedPaymentOption === "full"
      ? totalDebt
      : selectedPaymentOption === "minimum"
      ? minimumPayAmt
      : selectedPaymentOption === "custom"
      ? customAmt
      : 0;

  const goToPayment = () => {
    localStorage.setItem("dataLoanEnquiry", JSON.stringify(dataLoanEnquiry));
    navigate(`/payment`, {
      state: {
        rcData: rcData,
        policyDebt: policyDebt,
        radioAmt: selectedPaymentOption,
        paymentDebtDate: todayDate,
        debtAmt: debtAmt,
      },
    });
  };

  const formatNumber = (value) => {
    if (isNaN(value)) return "";
    return Number(value).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const handleCustomChange = (e) => {
    const input = e.target.value;
    const value = parseFloat(input.replace(/,/g, ""));

    setCustomAmt(value);

    if (!input || input.trim() === "") {
      setErrorText("กรุณาระบุจำนวนเงิน");
    } else if (isNaN(value)) {
      setErrorText("จำนวนเงินไม่ถูกต้อง");
    } else if (value > totalDebt) {
      setErrorText("จำนวนเงินเกินยอดเต็มจำนวน");
    } else if (value < minimumPayAmt) {
      setErrorText("จำนวนเงินที่ระบุไม่เพียงพอสำหรับชำระยอดขั้นต่ำ");
    } else {
      setErrorText("");
    }
  };

  //   const [displayValue, setDisplayValue] = useState("");
  // const [customAmt, setCustomAmt] = useState(null);
  // const [errorText, setErrorText] = useState("");

  const handleChange = (e) => {
    const raw = e.target.value;
    const selectionStart = e.target.selectionStart;

    let unformatted = raw.replace(/,/g, "").replace(/[^0-9.]/g, "");

    const parts = unformatted.split(".");
    if (parts.length > 2) {
      unformatted = parts[0] + "." + parts[1];
    }
    if (parts[1]?.length > 2) {
      unformatted = parts[0] + "." + parts[1].slice(0, 2);
    }

    if (!unformatted || isNaN(unformatted)) {
      setInputValue("");
      setCustomAmt(null);
      setErrorText("กรุณาระบุจำนวนเงิน");
      return;
    }

    const floatVal = parseFloat(unformatted);
    let [intPart, decimalPart] = unformatted.split(".");
    let formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    formatted += "." + (decimalPart ? (decimalPart + "00").slice(0, 2) : "00");

    setInputValue(formatted);
    setCustomAmt(floatVal);

    if (floatVal > totalDebt) {
      setErrorText("จำนวนเงินเกินยอดเต็มจำนวน");
    } else if (floatVal < minimumPayAmt) {
      setErrorText("จำนวนเงินที่ระบุไม่เพียงพอสำหรับชำระยอดขั้นต่ำ");
    } else {
      setErrorText("");
    }

    // ✅ เคลื่อน caret
    requestAnimationFrame(() => {
      if (
        inputRef.current &&
        typeof inputRef.current.setSelectionRange === "function"
      ) {
        const diff = formatted.length - raw.length;
        const newPos = (selectionStart || 0) + diff;
        inputRef.current.setSelectionRange(newPos, newPos);
      }
    });
  };

  return (
    <div>
      <Header_Home />
      <Header title={`เงินกู้ตามกรมธรรม์ที่รอการชำระ ณ วันที่ ${todayDate}`} />
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress
            sx={{
              animationDuration: "550ms",
            }}
            color="inherit"
          />
        </Backdrop>
      )}

      <div className="p-4">
        <div className="containers p-4">
          <h5
            style={{
              fontWeight: "bold",
              textAlign: "center",
              marginBottom: "20px",
            }}
          >
            อัตราดอกเบี้ย {dataLoanEnquiry.loanInterestRate} %
          </h5>
          {LoadingContent && (
            <>
              <Row className="card-custom3 d-flex">
                <Col className="mt-3">
                  <Skeleton style={{ height: "30px" }} />
                  <div className="d-flex flex-row justify-content-between">
                    <Skeleton />
                  </div>
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                  <Skeleton />
                </Col>
              </Row>
              <br />
            </>
          )}
          {!LoadingContent && dataLoanEnquiry && (
            <Tabs
              defaultActiveKey="home"
              id="fill-tab-example"
              fill
              className="mt-2"
              activeKey={activeTab}
              onSelect={handleSelect}
            >
              <Tab
                eventKey="home"
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "20px",
                    }}
                  >
                    <span>รายละเอียด</span>
                    <span>จำนวนเงิน(บาท)</span>
                  </div>
                }
              >
                <div className="card-custom">
                  <br />
                  <ul style={{ paddingLeft: "6px" }}>
                    <Grid container spacing={1}>
                      {/* === ชุดแรก: เงินกู้โดยระบบอัตโนมัติ === */}
                      <Grid item xs={6} sm={6}>
                        <span className="font-size-labels bold">
                          เงินกู้โดยระบบอัตโนมัติ :
                        </span>
                      </Grid>
                      <Grid item xs={6} sm={6} style={{ textAlign: "right" }}>
                        <span className="bold-detail">
                          {CurrencyFormater(dataLoanEnquiry.aplAmount)} บาท
                        </span>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <span className="font-size-labels">ดอกเบี้ย :</span>
                      </Grid>
                      <Grid item xs={6} sm={6} style={{ textAlign: "right" }}>
                        <span className="bold-detail">
                          {CurrencyFormater(dataLoanEnquiry.interestAplAmount)}{" "}
                          บาท
                        </span>
                      </Grid>
                      {/* === ชุดสอง: เงินกู้ตามกรมธรรม์ === */}
                      <Grid item xs={12} style={{ marginTop: 16 }} />{" "}
                      {/* เว้นบรรทัด */}
                      <Grid item xs={6} sm={6}>
                        <span className="font-size-labels bold">
                          เงินกู้ตามกรมธรรม์ :
                        </span>
                      </Grid>
                      <Grid item xs={6} sm={6} style={{ textAlign: "right" }}>
                        <span className="bold-detail">
                          {CurrencyFormater(dataLoanEnquiry.loanAmount)} บาท
                        </span>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <span className="font-size-labels">ดอกเบี้ย :</span>
                      </Grid>
                      <Grid item xs={6} sm={6} style={{ textAlign: "right" }}>
                        <span className="bold-detail">
                          {CurrencyFormater(dataLoanEnquiry.interestAmount)} บาท
                        </span>
                      </Grid>
                      {/* === จำนวนรวม === */}
                      <Grid item xs={12} />
                      <Grid item xs={6} sm={6}>
                        <span className="font-size-labels">จำนวนรวม :</span>
                      </Grid>
                      <Grid item xs={6} sm={6} style={{ textAlign: "right" }}>
                        <span className="bold-detail">{totalDebt} บาท</span>
                      </Grid>
                      {/* === จำนวนเงินขั้นต่ำ === */}
                      <Grid item xs={6} sm={6}>
                        <span className="font-size-labels">
                          จำนวนเงินขั้นต่ำที่ต้องชำระ :
                        </span>
                      </Grid>
                      <Grid item xs={6} sm={6} style={{ textAlign: "right" }}>
                        <span className="bold-detail">
                          {CurrencyFormater(minimumPayAmt)} บาท
                        </span>
                      </Grid>
                    </Grid>
                  </ul>
                </div>
                <Grid container spacing={1} style={{ marginTop: "20px" }}>
                  <Grid item xs={12}>
                    <FormControl component="fieldset" fullWidth>
                      <RadioGroup
                        name="paymentOption"
                        value={selectedPaymentOption}
                        onChange={(e) =>
                          setSelectedPaymentOption(e.target.value)
                        }
                      >
                        {[
                          {
                            value: "full",
                            label: "เต็มจำนวน",
                            amount: totalDebt,
                          },
                          {
                            value: "minimum",
                            label: "ขั้นต่ำ",
                            amount: CurrencyFormater(minimumPayAmt),
                          },
                          {
                            value: "custom",
                            label: "ระบุเอง",
                            amount: null,
                          },
                        ].map((option) => (
                          <FormControlLabel
                            key={option.value}
                            value={option.value}
                            control={
                              <Radio
                                sx={{
                                  color: "#000000",
                                  "&.Mui-checked": { color: "#f2654e" },
                                }}
                              />
                            }
                            style={{ marginBottom: 8 }}
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: "100%",
                                }}
                              >
                                <span style={{ minWidth: "80px" }}>
                                  {option.label}
                                </span>
                                {option.amount && (
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      marginLeft: "60px",
                                    }}
                                  >
                                    {option.amount} บาท
                                  </span>
                                )}
                              </div>
                            }
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                    <span style={{color:"red"}}>หากท่านชำระเงินกู้ตามกรมธรรม์แล้ว ระบบจะปรับปรุงข้อมูลภายใน 2 วัน</span>
                  </Grid>

                  {selectedPaymentOption === "custom" && (
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <NumericFormat
                        customInput={TextField}
                        thousandSeparator
                        decimalScale={2}
                        fixedDecimalScale
                        allowNegative={false}
                        value={customAmt ?? ""}
                        error={!!errorText}
                        helperText={errorText}
                        onValueChange={({ floatValue }) => {
                          const totalDebtNum =
                            typeof totalDebt === "number"
                              ? totalDebt
                              : Number(String(totalDebt).replace(/[^\d.-]/g, ""));   // "100,961.98 บาท" -> 100961.98
                        
                          const minimumPayAmtNum =
                            typeof minimumPayAmt === "number"
                              ? minimumPayAmt
                              : Number(String(minimumPayAmt).replace(/[^\d.-]/g, ""));
                        
                          setCustomAmt(floatValue);
                        
                          if (floatValue === undefined || floatValue === null) {
                            setErrorText("กรุณาระบุจำนวนเงิน");
                          } else if (isNaN(floatValue)) {
                            setErrorText("จำนวนเงินไม่ถูกต้อง");
                          } else if (floatValue > totalDebtNum) {
                            setErrorText("จำนวนเงินเกินยอดเต็มจำนวน");
                          } else if (floatValue < minimumPayAmtNum) {
                            setErrorText("จำนวนเงินที่ระบุไม่เพียงพอสำหรับชำระยอดขั้นต่ำ");
                          } else {
                            setErrorText("");
                          }
                        }}
                        
                        inputProps={{
                          style: {
                            fontWeight: "bold",
                            textAlign: "right",
                          },
                        }}
                        InputProps={{
                          // endAdornment: (
                          //   <InputAdornment position="end">
                          //     <span
                          //       style={{ color: "#999", fontWeight: "bold",fontFamily:"Prompt-Thin" }}
                          //     >
                          //       บาท
                          //     </span>
                          //   </InputAdornment>
                          // ),
                          sx: {
                            borderRadius: "20px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#ccc",
                            },
                          },
                        }}
                        fullWidth
                      />
                    </Grid>
                  )}
                </Grid>
              </Tab>
            </Tabs>
          )}
          <Row className="d-flex flex-column mt-2 mb-5">
            {/* {rcData.policyPaymentAllowFlag == "Y" &&
            rcData.paymentFlagIservice == "N" && ( */}
            {/* <Col className="d-flex justify-content-end px-5 gap-2">
              <button
                style={{ fontSize: 18 }}
                // onClick={goToPayment}
                className="btn-checkout-premium w-100 p-2 bold"
              >
                กู้เงิน
              </button>
            </Col> */}
            {/* )} */}
            <Grid item xs={12} sm={6}>
              <button
                onClick={goBack}
                className="btn-coupon-back w-sm-100 w-lg-25 p-2 bold text-black"
              >
                ย้อนกลับ
              </button>
            </Grid>
            {(dataLoanEnquiry.aplAmount > 0 ||
              dataLoanEnquiry.loanAmount > 0) && (
              <Grid item xs={12} sm={6}>
                <button
                  style={{ fontSize: 18 }}
                  onClick={goToPayment}
                  disabled={
                    !!errorText ||
                    (selectedPaymentOption === "custom" && !customAmt)
                  }
                  // className="btn-send-doc w-100 p-2 bold"
                  className={`btn-send-doc w-100 p-2 bold ${
                    errorText ? "btn-disable" : ""
                  }`}
                >
                  ชำระคืนเงินกู้ตามกรมธรรม์
                </button>
              </Grid>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default PolicyDebt;
